<template>
  <div class="app-table-container">
    <!-- 查询条件 -->
    <el-form :model="queryForm">
        <el-row>
          <el-col :span="6">
            <el-form-item label="套餐名称" :label-width="formLabelWidth">
              <el-input v-model="queryForm.title" maxlength="9" size="small" placeholder="请输入名称" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="店铺" :label-width="formLabelWidth">
                 <el-select
                   :disabled="control.disabled"
                   v-model="queryForm.storeId"
                   clearable
                   filterable
                   size="small"
                   placeholder="请选择">
                 <el-option
                   v-for="item in stores"
                   :key="item.id"
                   :label="item.storeName"
                   :value="item.id"
                 />
               </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="1">
            <el-form-item :label-width="formLabelWidth">
              <el-button type="primary" size="small" @click="handlePage()">搜索</el-button>
              <el-button size="small" @click="reset()">重置</el-button>
            </el-form-item>
          </el-col>
      </el-row>
    </el-form>
    <!-- 数据表格 -->
    <el-table
      stripe
      :header-cell-style="{ background:'#eef1f6', color:'#606266' }"
      :data="tableData"
      :height="tableHeight"
      ref="tableContainer"
      class="table-container">
      <!-- <el-table-column prop="id" label="id" type="selection" fixed></el-table-column> -->
      <el-table-column
        fixed
        prop="title"
        label="套餐名称"
        levelKey="depth"
        treeKey="id"
        parentKey="parentId"
        childKey="children"
        min-width="120px">
        </el-table-column>

      <el-table-column
        prop="picUrl"
        label="套餐主图">
        <template slot-scope="scope">
          <el-image
            style ="width:60px; height: 60px"
            :src="scope.row.picUrl"
            :preview-src-list="[scope.row.picUrl]"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="desc1"
        label="菜单描述"/>

      <el-table-column
        prop="screenPrice"
        label="原价"/>

      <el-table-column
        prop="price"
        label="现价"/>

      <el-table-column
        prop="stockNumber"
        label="余量"/>

      <el-table-column
        prop="profitAmount"
        label="返现比例%"/>

      <el-table-column
        prop="ratioFlag"
        label="是否分成">
        <template slot-scope="scope">
          {{scope.row.ratioFlag?'是':'否'}}
        </template>
      </el-table-column>

      <el-table-column
        prop="ratioType"
        label="分成类型">
        <template slot-scope="scope">
          {{scope.row.ratioTypeLabel}}
        </template>
      </el-table-column>

      <el-table-column
        prop="ratio"
        label="比例|金额">
        <template slot-scope="scope">
          {{scope.row.ratio}}
          {{scope.row.ratioType=='FIXED_AMOUNT'?'':'%'}}
        </template>
      </el-table-column>

      <el-table-column
        prop="priceTips"
        label="价格报错"
        min-width="100px">
        <template slot-scope="scope">
          <div><span>抖音售价：{{scope.row.douyinPrice}}</span><span style="color: red;margin-left: 8px;">{{scope.row.douyinPriceTip}}</span></div>
          <div><span>美团点评售价：{{scope.row.dianpingPrice}}</span><span style="color: red;margin-left: 8px;">{{scope.row.dianpingPriceTip}}</span></div>
        </template>
      </el-table-column>

      <el-table-column
        prop="storeName"
        label="店铺名称"
        min-width="80px">
        <template slot-scope="scope">
          {{scope.row.store?scope.row.store.storeName:''}}
        </template>
      </el-table-column>

      <el-table-column
        prop="publishFlag"
        label="发布状态"
        min-width="80px">
        <template slot-scope="scope">
          <el-button @click="$permits.has(targetPermit,$permits.CREATE)?handlePublish(scope.row):''"  :type="scope.row.publishFlag?'success':'info'" size="mini" round>
            {{scope.row.publishFlag?'已发布':'未发布'}}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column fixed="right" min-width="200px">
        <template slot="header">
          <span style="float: left">操作</span>
          <el-button
              style="float: right;"
              type="primary" size="mini"
              v-show="$permits.has(targetPermit,$permits.CREATE)"
              @click="handleAction($permits.CREATE)">
            + 新建
          </el-button>
        </template>
        <template slot-scope="scope">
          <!-- <el-button v-show="$permits.has(targetPermit,$permits.VIEW)" @click="handleAction($permits.VIEW,scope.row)" size="mini" type="success" round>详情</el-button> -->
          <el-button v-show="$permits.has(targetPermit,$permits.UPDATE)" @click="handleAction($permits.UPDATE,scope.row)" size="mini" type="warning" round>编辑</el-button>
          <el-button v-show="$permits.has(targetPermit,$permits.REMOVE)" @click="handleRemove(scope.row)" size="mini" type="danger" round>删除</el-button>
          <el-button v-show="$permits.has(targetPermit,$permits.UPDATE)" @click="handleTask(scope.row)" size="mini" type="primary" round>任务</el-button>
          <el-button v-show="$permits.has(targetPermit,$permits.UPDATE)" @click="handleSchedule(scope.row)" size="mini" type="info" round>排期</el-button>
        </template>
      </el-table-column>

    </el-table>

    <!-- 分页 -->
    <el-row>
      <el-col>
        <div class="pagination">
          <el-pagination background
            v-if="paginations.total>0"
            :page-sizes="paginations.pages"
            :page-size="paginations.size"
            :layout="paginations.layout"
            :total="paginations.total"
            :current-page.sync="paginations.current"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"/>
        </div>
      </el-col>
    </el-row>
    <setmeal-form v-if="control.show" :control="control" :stores="stores" :enums="enums" :parents="parents" />
    <setmeal-task-page v-if="controlTask.show" :controlTask="controlTask" :stores="stores" :enums="enums" :parents="parents"></setmeal-task-page>
    <setmeal-schedule-page v-if="controlSchedule.show" :controlSchedule="controlSchedule" :stores="stores" :enums="enums" :parents="parents"></setmeal-schedule-page>
  </div>
</template>
<script>
import * as OrganizationApi from '@/api/organization'
import * as EnumApi from '@/api/enums'
import * as SetmealApi from '@/api/setmeal'
import SetmealForm from './form'
import SetmealTaskPage from './task/page'
import SetmealSchedulePage from './schedule/page'
import { buildTree,treeToList } from '@/utils'
export default {
  name: 'Setmeal',
  components: {
    SetmealForm,
    SetmealTaskPage,
    SetmealSchedulePage
  },
  data() {
    return {
      formLabelWidth: '80px',
      stores: [],
      enums: [],
    	// 权限key
      targetPermit: 'setmeal',
      tableHeight: 0,
      queryForm: {
        title: '',
        storeId: '',
        current: 1,
        size: 10
      },
      control: {
        show: false,
        title: '',
        action: this.$permits.VIEW,
        form: '',
        disabled: false
      },
      controlTask: {
        show: false,
        title: '',
        action: this.$permits.VIEW,
        form: '',
        disabled: false
      },
      controlSchedule: {
        show: false,
        title: '',
        action: this.$permits.VIEW,
        form: '',
        disabled: false
      },
      tableData: [],
      parents: [],
      paginations: {
        current: 1, // 当前页
        total: 0, // 总行数
        size: 10, // 每页行数
        sizes: [10, 20, 30, 40], // 每页行数 调整
        layout: 'total, sizes, prev, pager, next, jumper' // 翻页属性
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = this.$refs.tableContainer.$el.offsetHeight;
    })
    this.handleEnum()
    this.handlePage()
    this.doGetStores()
  },
  methods: {
    // 重置
    reset() {
      Object.keys(this.queryForm).forEach(key => (this.queryForm[key] = ''))
      this.handlePage()
    },
    handleAction(action,item) {
      let that = this;
      console.log("action >> " + action)
      that.control.show = true;
      that.control.disabled = false;
      that.control.action = action;

      switch(action){
        case that.$permits.VIEW:
          that.control.title = "详情";
          that.control.disabled = true;
          that.control.form = item;
          console.log("switch >>> " + that.$permits.VIEW)
          break;
        case that.$permits.UPDATE:
          that.control.title = "编辑";
          that.control.form = item;
          console.log("switch >>> " + that.$permits.UPDATE)
          break;
        case that.$permits.CREATE:
          that.control.title = "新建";
          console.log("switch >>> " + that.$permits.CREATE)
          break;
      }
    },
    handleTask(item) {
      let that = this;
      that.controlTask.show = true;
      that.controlTask.disabled = false;
      that.controlTask.title = "任务";
      that.controlTask.form = item;
    },
    handleSchedule(item) {
      let that = this;
      that.controlSchedule.show = true;
      that.controlSchedule.disabled = false;
      that.controlSchedule.title = "库存排期";
      that.controlSchedule.form = item;
    },
    handleRemove(item) {
      let that = this;
      that.$confirm('', '确定删除吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        SetmealApi.remove(item.id).then(res => {
          that.handlePage();
        });
      }).catch((e) => {console.log('error', e)});
    },
    handleEnable(item) {
      let that = this;
      let tip = !item.enableFlag?'启用':'停用'
      that.$confirm('', '确定'+tip+'吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        SetmealApi.enabled({id: item.id, enabled: !item.enableFlag}).then(res => {
          that.handlePage();
        });
      }).catch((e) => {console.log('error', e)});
    },
    handlePublish(item) {
      let that = this;
      let tip = !item.publishFlag?'发布':'取消发布'
      that.$confirm('', '确定'+tip+'吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        SetmealApi.published({id: item.id, enabled: !item.publishFlag}).then(res => {
          that.handlePage();
        });
      }).catch((e) => {console.log('error', e)});
    },
    handleEnum() {
      let that = this;
      // 获取表格数据
      EnumApi.list().then(res => {
        let result = res.data.data;
        that.enums = result
      })
    },
    handlePage(current) {
      console.log('current', current)
      let that = this;
      if (current) {
        that.paginations.current = current
      }
      that.queryForm.current = that.paginations.current
      that.queryForm.size = that.paginations.size
      // 获取表格数据
      SetmealApi.page(that.queryForm).then(res => {
        let result = res.data.data;
        that.tableData = result.records
        that.paginations.total = Number(result.total)
        that.paginations.current = Number(result.current)
        that.paginations.size = Number(result.size)
      })
    },
    doGetStores() {
      OrganizationApi.page({enableFlag: true}).then(res => {
        let result = res.data.data;
        this.stores = result.records
      })
    },
    handleCurrentChange(page) {
      // 切换页码
      this.paginations.current = page
      this.handlePage()
    },
    handleSizeChange(size) {
      // 切换size
      this.paginations.size = size
      this.size = size
      this.handlePage()
    }
  }
}
</script>

<style scoped lang="scss">

</style>
